import { ActivitiesDefaultLimit } from '../types';

export const DefaultActivitiesAndNotificationsFilters = {
  page: 1,
  limit: ActivitiesDefaultLimit,
  events: [],
  offers: [],
  talentPools: [],
  startDate: '',
  endDate: '',
  cursorPosition: null,
  cursorOrder: 'desc',
};
